import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-produtividade-metas',
  standalone: true,
  imports: [CommonModule, MatTooltipModule],
  templateUrl: './produtividade-metas.component.html',
  styleUrl: './produtividade-metas.component.css'
})
export class ProdutividadeMetasComponent implements OnInit {
 
  @Input() maxValue!: number;
  @Input() currentValue!: number;
  @Input() expectedValue!: number;

  public porcBarraReal!: number;
  public porcBarraIdeal!: number;
  public exibirDisplayReal: boolean = true;
  public exibirDisplayIdeal: boolean = true;

  ngOnInit(): void {
    this.calcularPorcentagens();
    this.gerenciaVisibilidadeDisplay();
  }

  public formatarValor(valor: number): string {
    if (valor === undefined || valor === null) return '0';
    
    if (Number.isInteger(valor)) {
      return valor.toString();
    }
    
    return valor.toFixed(2);
  }

  public calcularPorcentagens(): void {
    this.porcBarraReal = (this.currentValue / this.maxValue) * 100;
    this.porcBarraReal = this.porcBarraReal > 100 ? 100 : this.porcBarraReal;

    this.porcBarraIdeal = (this.expectedValue / this.maxValue) * 100;
    this.porcBarraIdeal = this.porcBarraIdeal > 100 ? 100 : this.porcBarraIdeal;
  }

  public gerenciaVisibilidadeDisplay(): void {
    this.exibirDisplayReal = this.porcBarraReal > 6.5;

    const diferenca = this.porcBarraIdeal - this.porcBarraReal;
    this.exibirDisplayIdeal = diferenca > 10;
  }
}